module.exports = __webpack_public_path__ + "img/portfolio-Mockup-MacBook.09f46ab7.jpg";